import $ from 'jquery'
import JsEnabledFunction from './components/jsEnabled'
import { Screenmode } from './components/screenmode'
import FocusStyleClass from './components/focusStyle'
import HeaderClass from './components/header'
import { Tracking } from './components/tracking'
import { initCookiebotOverlayHandler } from './components/helper'

if (document.querySelector('lottie-player')) {
  import('@lottiefiles/lottie-player')
}

const ready = (callback) => {
  if (document.readyState !== 'loading') callback()
  else document.addEventListener('DOMContentLoaded', callback)
}

ready(() => {
  // Add class js, remove class no-js from html-tag
  JsEnabledFunction()

  // Set breakpoint classes
  const screenmode = new Screenmode()
  screenmode.init()

  // Add focus behaviour
  const focusStyle = new FocusStyleClass()
  focusStyle.init()

  // Add anchor jump
  if (document.querySelector('.btn--to-top, .btn--to-top-fixed,a[href*="#"][href*="' + window.location.host + '"],a[href^="/"][href*="#"]:not([href^="//"]),.page-header')) {
    import('./components/jumpToAnchor')
      .then(({ JumpToAnchor }) => {
        const jumpToAnchor = new JumpToAnchor()
        jumpToAnchor.init()
      })
  }

  // Add alert popup
  if (document.querySelector('.alert-popup')) {
    import('./components/alertPopup')
      .then(({ AlertPopup }) => {
        const alertPopup = new AlertPopup()
        alertPopup.init()
      })
  }

  // Add scrolling animations
  if (document.querySelector('.hero-teaser,.big-header-teaser,.teaser-group__item,.news-list--boxes .news-list__item,.page__top-image,.advantage-calculator__summary-price')) {
    import('./components/scrollingAnimation')
      .then(({ ScrollingAnimation }) => {
        const scrollingAnimation = new ScrollingAnimation()
        scrollingAnimation.init()
      })
  }

  // Add scroll function for header
  const header = new HeaderClass()
  header.init()

  // init cookiebot handling
  if (typeof Cookiebot !== 'undefined') {
    initCookiebotOverlayHandler()
  }

  // Add read more function
  if ($('.read-more').length > 0) {
    import('./components/readMore')
      .then(({ ReadMore }) => {
        const readmore = new ReadMore()
        readmore.init()
      })
  }

  // add download filter
  if ($('.download-center').length > 0) {
    import('./components/meDownloadFilter')
      .then(({ MeDownloadFilter }) => {
        const downloadFilter = new MeDownloadFilter()
        downloadFilter.init()
      })
  }

  // Logout section
  if ($('.logoutSection').length > 0) {
    import('./components/logoutSection')
      .then(({ LogoutSection }) => {
        const logoutSection = new LogoutSection()
        logoutSection.init()
      })
  }

  // Add dynamic select boxes, based on viewport
  if ($('.dynamic-select, select:not(.form__select--no-replace)').length > 0) {
    import('./components/dynamicSelect')
      .then(({ DynamicSelect }) => {
        const dynamicSelect = new DynamicSelect()
        dynamicSelect.init()
      })
  }

  // Add slick slider for teaser group
  if ($('.slider, .slider-only').length > 0) {
    import('./components/teaserGroup')
      .then(({ TeaserGroup }) => {
        const teaserGroup = new TeaserGroup()
        teaserGroup.init()
      })
  }

  // Add search overlay
  if ($('.search-overlay').length > 0) {
    import('./components/searchOverlay')
      .then(({ SearchOverlay }) => {
        const searchOverlay = new SearchOverlay()
        searchOverlay.init()
      })
  }

  // Add contact overlay
  if ($('.contact-overlay').length > 0) {
    import('./components/contactOverlay')
      .then(({ ContactOverlay }) => {
        const contactOverlay = new ContactOverlay()
        contactOverlay.init()
      })
  }

  // Add info request overlay
  if ($('.info-request-overlay').length > 0) {
    import('./components/infoRequestOverlay')
      .then(({ InfoRequestOverlay }) => {
        const infoRequestOverlay = new InfoRequestOverlay()
        infoRequestOverlay.init()
      })
  }

  // Add collapse events
  if ($('.collapse-block__item').length > 0) {
    import('./components/collapse')
      .then(({ Collapse }) => {
        const collapse = new Collapse()
        collapse.init()
      })
  }

  // Change link box height
  if ($('.link-box').length > 0) {
    import('./components/linkBox')
      .then(({ LinkBox }) => {
        const linkBox = new LinkBox()
        linkBox.init()
      })
  }

  // Add youtube
  if ($('.video__container--youtube').length > 0) {
    import('./components/video')
      .then(({ Video }) => {
        const video = new Video()
        video.checkCookie()
      })
  }

  // Change link box height
  if ($('.icon-box--detail-view').length > 0) {
    import('./components/iconBox')
      .then(({ IconBox }) => {
        const iconBox = new IconBox()
        iconBox.init()
      })
  }

  // Add info popup
  import('./components/infoPopup')
    .then(({ InfoPopup }) => {
      const infoPopup = new InfoPopup()
      infoPopup.init()
    })

  // Add advantage calculator
  if ($('.advantage-calculator').length > 0) {
    import('./components/advantageCalculator')
      .then(({ AdvantageCalculator }) => {
        const advantageCalculator = new AdvantageCalculator()
        advantageCalculator.init()
      })
  }

  // Add journal form switch functions
  if ($('.journal_select').length > 0) {
    import('./components/journalForm')
      .then(({ JournalForm }) => {
        const journalForm = new JournalForm()
        journalForm.init()
      })
  }

  // initialize chatbot
  import('./components/chatbot')
    .then(({ Chatbot }) => {
      const chatbot = new Chatbot()
      chatbot.init()
    })

  // Add form functions
  if ($('.form__upload, .form_select').length > 0) {
    import('./components/forms')
      .then(({ Forms }) => {
        const forms = new Forms()
        forms.init()
      })
  }

  // Add job form switch functions
  if ($('.powermail_fieldset.doc-uploads').length > 0) {
    import('./components/jobform')
      .then(({ Jobform }) => {
        const jobForm = new Jobform()
        jobForm.init()
      })
  }

  // Add Search Dropdown
  if ($('.search-dropdown').length > 0) {
    import('./components/searchDropown')
      .then(({ SearchDropown }) => {
        const searchDropown = new SearchDropown()
        searchDropown.init()
      })
  }

  // Add table of contents list
  if ($('.table-of-contents').length > 0) {
    import('./components/tableOfContents')
      .then(({ TableOfContents }) => {
        const tableOfContents = new TableOfContents()
        tableOfContents.init()
      })
  }

  // Add modal variant 1
  if ($('.modal--variant-1').length > 0) {
    import('./components/modalVariant1')
      .then(({ ModalVariant1 }) => {
        const modalVariant1 = new ModalVariant1()
        modalVariant1.init()
      })
  }

  // Add contrast button
  import('./components/contrastButton')
    .then(({ ContrastButton }) => {
      const contrastButton = new ContrastButton()
      contrastButton.init()
    })

  // Add tracking
  const tracking = new Tracking()
  tracking.init()

  // Inline svg
  if ($('img[src$=".svg"]').length > 0) {
    import('jquery-inline-svg')
      .then(() => {
        $('img[src$=".svg"]')
          .on('load', function () {
            $(this)
              .inlineSvg()
              .data('loaded', '1')
          })

        $('img')
          .each(function () {
            if (this.complete) {
              $(this).trigger('load')
            }
          })
      })
  }
})

$(window)
  .on('load', function () {
    // Add image gallery slider
    if ($('.image-slider__container').length > 0) {
      import('./components/imageGallery')
        .then(({ ImageGallery }) => {
          const imageGallery = new ImageGallery()
          imageGallery.init()
        })
    }

    // Validate Friendly Captcha before form submit
    if (document.getElementById('cleverreach-newsletterform')) {
      const newsletterform = document.getElementById('cleverreach-newsletterform')
      newsletterform.addEventListener('submit', onFriendlyCaptchaFormSubmit)
    }

    // Validate Friendly Captcha before form submit
    const bonusplandatas = [...document.querySelectorAll('form.bonusplandata')]
    bonusplandatas.forEach(bonusplandatas => {
      bonusplandatas.addEventListener('submit', onFriendlyCaptchaFormSubmit)
    })
  })

async function onFriendlyCaptchaFormSubmit (event) {
  try {
    event.preventDefault()

    const formData = new FormData(event.target)
    const dataObject = Object.fromEntries(formData.entries())

    const notReadyErrorHtml = '<p class="friendly-captcha-check-error">Friendly Catpcha ist noch nicht fertig.</p>'
    const unsuccessfulErrorHtml = '<p class="friendly-captcha-check-error">Friendly Catpcha ist noch nicht fertig.</p>'
    const captcha = document.querySelector('.frc-captcha')

    if (dataObject['frc-captcha-solution'] === '.UNFINISHED') {
      captcha.parentElement.innerHTML = captcha.parentElement.innerHTML + notReadyErrorHtml
      return
    }

    const solution = dataObject['frc-captcha-solution']
    const url = '/?type=1500000456'
    const payload = { solution }

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })

    const result = await response.json()
    if (result === true) {
      console.log('Captcha-Überprüfung erfolgreich.')
      event.target.submit()
    } else {
      captcha.parentElement.innerHTML = captcha.parentElement.innerHTML + unsuccessfulErrorHtml
      console.log('Captcha-Überprüfung fehlgeschlagen.')
    }
  } catch (error) {
    console.error('Ein Fehler ist aufgetreten:', error)
  }
}
